import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParticleBackground from "@/components/ParticleBackground";
import AIGrid from "@/components/AIGrid";
import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const Imprint = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-background relative overflow-hidden">
      <ParticleBackground />
      <AIGrid />
      <Navigation />

      <main className="flex-grow pt-32 pb-20 relative z-10">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-4">{t('imprint.title')}</h1>
            <p className="text-muted-foreground text-lg">{t('imprint.subtitle')}</p>
          </motion.div>

          <Card className="p-8 glass-effect border-primary/30 max-w-4xl mx-auto">
            <div className="space-y-6 text-sm leading-relaxed text-muted-foreground">
              <section>
                <h2 className="text-xl font-semibold mb-4">{t('imprint.section_legal_info_title')}</h2>
                <div className="space-y-2">
                  <p><strong>{t('imprint.company')}:</strong> {t('imprint.company_name')}</p>
                  <p><strong>{t('imprint.address')}:</strong><br />
                    {t('imprint.street')}<br />
                    {t('imprint.city')}
                  </p>
                  <p><strong>{t('imprint.contact')}:</strong><br />
                    {t('imprint.telephone')}: {t('imprint.phone_number')}<br />
                    {t('imprint.email')}: {t('imprint.email_address')}
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">{t('imprint.section_legal_representation_title')}</h2>
                <div className="space-y-2">
                  <p><strong>{t('imprint.represented_by')}:</strong> {t('imprint.director_name')}</p>
                  <p><strong>{t('imprint.vat_id')}:</strong> {t('imprint.vat_id_number')}</p>
                  <p><strong>{t('imprint.commercial_register')}:</strong> {t('imprint.register_number')}</p>
                  <p><strong>{t('imprint.supervisory_authority')}:</strong> {t('imprint.authority_name')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">{t('imprint.section_eu_dispute_title')}</h2>
                <div className="space-y-2">
                  <p>{t('imprint.eu_dispute_desc')}</p>
                  <p><a href="https://ec.europa.eu/consumers/odr" className="text-primary hover:text-accent transition-colors" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a></p>
                  <p>{t('imprint.eu_dispute_email')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4">{t('imprint.section_consumer_dispute_title')}</h2>
                <p>{t('imprint.consumer_dispute_desc')}</p>
              </section>

              <div className="text-xs mt-8 pt-4 border-t border-muted">
                <p>{t('imprint.last_updated')}: {t('imprint.last_updated_date')}</p>
              </div>
            </div>
          </Card>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Imprint;


